import React, { memo } from 'react'
import VideoListView from './view/VideoList.view'
import useVideoListHook from './hooks/useVideoList.hook'

export default memo((props: any) => {
  const newState = useVideoListHook()
  return <VideoListView {...props} {...newState} />
})
